import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function WhatsAppButton() {
  const text = encodeURIComponent(
    "Hello RK Enterprises, I would like to know more about your manpower services."
  );
  const href = `https://wa.me/${BRAND.whatsapp}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#059669] hover:bg-[#047857] text-white pl-3 pr-4 py-3 shadow-xl rk-pulse transition-colors"
    >
      <span className="grid place-items-center h-8 w-8 rounded-full bg-white/15">
        <MessageCircle className="h-5 w-5" />
      </span>
      <span className="hidden sm:inline text-sm font-semibold">
        Chat on WhatsApp
      </span>
    </a>
  );
}
